import { render, staticRenderFns } from "./RecipeNutritionForm.vue?vue&type=template&id=a10276f2&scoped=true"
import script from "./RecipeNutritionForm.vue?vue&type=script&lang=js"
export * from "./RecipeNutritionForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeNutritionForm.vue?vue&type=style&index=0&id=a10276f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10276f2",
  null
  
)

export default component.exports